export enum UserTypes {
  Admin = 1,
  AdvertiserAdmin = 2,
  AccountsManager = 3,
  ChainAdmin = 4,
}
